import { configureStore } from "@reduxjs/toolkit";
import categoryReducers from "../features/Category/CategorySlice";
import subcategoryReducers from"../features/Subcategory/SubcategorySlice";
import productReducers from"../features/Product/ProductSlice";
import serviceReducers from "../features/Service/ServiceSlice";
import govermentReducers from "../features/Govermentschme/GovermentschmeSlice";
import contactUsReducers from "../features/ContactUs/ContactUsSlice";
import userReducers from "../features/User/UserSlice";

export const store = configureStore({
  reducer: {
    category: categoryReducers,
    subcategory: subcategoryReducers,
    product: productReducers,
    service: serviceReducers,
    govermentschme: govermentReducers,
    contactus: contactUsReducers,
     user: userReducers,
  },
});
